var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-container-content", attrs: { id: "boxInfo" } },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            inline: true,
            "label-position": "top",
            model: _vm.form,
            disabled: _vm.showdisabled,
          },
        },
        [
          _vm.titleFlag == ""
            ? _c(
                "div",
                { staticClass: "filter-container-title" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("home.dropTitle")) + " "),
                      _c("div", { staticClass: "title-total" }, [
                        _vm._v(
                          _vm._s(_vm.$t("home.total")) + ":" + _vm._s(_vm.total)
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-plus",
                        disabled: _vm.showdisabled || _vm.preLockFlag,
                      },
                      on: { click: _vm.handleAddBox },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.dropTitle")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.titleFlag == "2"
            ? _c(
                "div",
                { staticClass: "filter-container-title" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("home.dropTitlePrevious")) + " "),
                      _c("div", { staticClass: "title-total" }, [
                        _vm._v(
                          _vm._s(_vm.$t("home.total")) + ":" + _vm._s(_vm.total)
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-plus",
                        disabled: _vm.showdisabled || _vm.preLockFlag,
                      },
                      on: { click: _vm.handleAddBox },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.dropTitle")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.titleFlag == "3"
            ? _c(
                "div",
                { staticClass: "filter-container-title" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("home.dropTitleCurrent")) + " "),
                      _c("div", { staticClass: "title-total" }, [
                        _vm._v(
                          _vm._s(_vm.$t("home.total")) + ":" + _vm._s(_vm.total)
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-plus",
                        disabled: _vm.showdisabled || _vm.preLockFlag,
                      },
                      on: { click: _vm.handleAddBox },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.dropTitle")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-container-new-back" },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: { data: _vm.form.webBkPreContainerComs },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("home.No"),
                      width: "60",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: { prop: "containerType" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "webBkPreContainerComs." +
                                      scope.$index +
                                      ".containerType",
                                    rules: _vm.rules.containerType,
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      class: _vm.tableClass(
                                        "containerType" + scope.$index
                                      ),
                                      attrs: { disabled: _vm.preLockFlag },
                                      model: {
                                        value: scope.row.containerType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "containerType",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.containerType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.containerTypeList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: String(item),
                                            value: item,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("span", { staticClass: "required-marker" }, [
                          _vm._v(" *"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "required-marker" }, [
                          _vm._v(_vm._s(_vm.$t("home.containerType"))),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "webBkPreContainerComs." +
                                      scope.$index +
                                      ".quantity",
                                    rules: _vm.rules.quantity,
                                  },
                                },
                                [
                                  _c("el-input-number", {
                                    class: _vm.tableClass(
                                      "quantity" + scope.$index
                                    ),
                                    attrs: {
                                      precision: 0,
                                      "auto-cut": true,
                                      controls: false,
                                      max: 9999999,
                                      disabled: _vm.preLockFlag,
                                    },
                                    model: {
                                      value: scope.row.quantity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "quantity",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "scope.row.quantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("span", { staticClass: "required-marker" }, [
                          _vm._v(" *"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "required-marker" }, [
                          _vm._v(_vm._s(_vm.$t("home.quantity"))),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: { prop: "cargoTypeCode" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "webBkPreContainerComs." +
                                      scope.$index +
                                      ".cargoTypeCode",
                                    rules: _vm.rules.cargoTypeCode,
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { disabled: _vm.preLockFlag },
                                      model: {
                                        value: scope.row.cargoTypeCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "cargoTypeCode",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.cargoTypeCode",
                                      },
                                    },
                                    _vm._l(_vm.cargoList, function (item) {
                                      return _c("el-option", {
                                        key: item.code,
                                        attrs: {
                                          label:
                                            _vm.language === "zh"
                                              ? item.nameCn
                                              : item.name,
                                          value: item.code,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("span", { staticClass: "required-marker" }, [
                          _vm._v(" *"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "required-marker" }, [
                          _vm._v(_vm._s(_vm.$t("home.cargoTypeCodeOne"))),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pickUpDate",
                      label: _vm.$t("home.pickUpDate"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              [
                                _c("el-date-picker", {
                                  class: _vm.tableClass(
                                    "pickUpDate" + scope.$index
                                  ),
                                  attrs: {
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "picker-options": _vm.pickerStartDate(
                                      scope.$index
                                    ),
                                    type: "date",
                                    disabled: _vm.preLockFlag,
                                  },
                                  model: {
                                    value: scope.row.pickUpDate,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "pickUpDate", $$v)
                                    },
                                    expression: "scope.row.pickUpDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "returnDate",
                      label: _vm.$t("home.retureDate"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              [
                                _c("el-date-picker", {
                                  class: _vm.tableClass(
                                    "returnDate" + scope.$index
                                  ),
                                  attrs: {
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "picker-options": _vm.pickerCloseDate(
                                      scope.$index
                                    ),
                                    type: "date",
                                    disabled: _vm.preLockFlag,
                                  },
                                  model: {
                                    value: scope.row.returnDate,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "returnDate", $$v)
                                    },
                                    expression: "scope.row.returnDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("home.pickUpDepot") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              [
                                _c("glPortFacility", {
                                  class: _vm.tableClass(
                                    "pickUpDepot" + scope.$index
                                  ),
                                  attrs: { disabled: _vm.preLockFlag },
                                  model: {
                                    value: scope.row.pickUpDepot,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "pickUpDepot", $$v)
                                    },
                                    expression: "scope.row.pickUpDepot",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: _vm.$t("home.returnDepot") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              [
                                _c("glPortFacility", {
                                  class: _vm.tableClass(
                                    "returnDepot" + scope.$index
                                  ),
                                  attrs: { disabled: _vm.preLockFlag },
                                  model: {
                                    value: scope.row.returnDepot,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "returnDepot", $$v)
                                    },
                                    expression: "scope.row.returnDepot",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("i", {
                              staticClass: "el-icon-remove-outline",
                              class: { disabled: _vm.showdisabled },
                              attrs: { hidden: _vm.preLockFlag },
                              on: {
                                click: function ($event) {
                                  !_vm.showdisabled &&
                                    _vm.handleRemoveBox(scope.row, scope.$index)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }